import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import orbitVariantImg from "../assets/orbit_variant.png";

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 5%;
  position: relative;
  overflow: hidden;
  text-align: center;
  background-color: #000;

  @media (max-width: 768px) {
    padding: 0 1rem;
    min-height: 100svh;
  }
`;

const SplineContainerBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;

    @media (max-width: 768px) {
      object-fit: cover;
      object-position: center top;
      opacity: 0.8;
    }
  }
`;

const Content = styled.div`
  max-width: 1000px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  margin-bottom: 2rem;
  font-weight: 800;
  font-size: clamp(2.5rem, 8vw, 6rem);
  line-height: 1.1;
  letter-spacing: -0.02em;

  .orange-text {
    background: linear-gradient(90deg, #ff8a50 0%, #ff5722 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: block;
  }

  .white-text {
    color: #ffffff;
    display: block;
  }

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
    font-size: clamp(2rem, 10vw, 3.5rem);
  }
`;

const FeaturesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    margin-top: 0.5rem;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 500;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    gap: 0.75rem;
  }
`;

const StarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C12 2 13 8 16 11C18.6667 13.6667 22 13 22 13C22 13 16.5 14.5 14 17C11.3333 19.6667 11 22 11 22C11 22 10 16 7.5 13C5 10 2 9 2 9C2 9 7.5 7.5 9.5 5.5C11.5 3.5 12 2 12 2Z"
      fill="url(#starGradient)"
    />
    <defs>
      <linearGradient
        id="starGradient"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB74D" />
        <stop offset="1" stopColor="#FF5722" />
      </linearGradient>
    </defs>
  </svg>
);

export const HeroVariant: React.FC = () => {
  const { t } = useTranslation();
  return (
    <HeroContainer>
      <SplineContainerBackground>
        <img src={orbitVariantImg} alt="Orbit Variant" />
      </SplineContainerBackground>
      <Content>
        <Title>
          <span className="orange-text">{t("hero_variant.title_part1")}</span>
          <span className="white-text">{t("hero_variant.title_part2")}</span>
        </Title>

        <FeaturesContainer>
          <FeatureItem>
            <StarIcon /> {t("hero_variant.feature1")}
          </FeatureItem>
          <FeatureItem>
            <StarIcon /> {t("hero_variant.feature2")}
          </FeatureItem>
          <FeatureItem>
            <StarIcon /> {t("hero_variant.feature3")}
          </FeatureItem>
        </FeaturesContainer>
      </Content>
    </HeroContainer>
  );
};

